import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { Box, Typography, useTheme, alpha } from '@mui/material';

const ChartDonut = ({ title, value, data, color }) => {
  const theme = useTheme();
  // Tratamento de dados mais robusto
  let parsedData = [];
  try {
    // Se data for array de strings JSON (como no original), parse
    if (data.length > 0 && typeof data[0] === 'string') {
      parsedData = data.map(item => JSON.parse(item.replace(/'/g, '"')));
    } else {
      parsedData = data;
    }
  } catch (e) {
    parsedData = [];
  }

  const COLORS = Array.isArray(color) ? color : [color];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%' }}>
      <Box sx={{ position: 'relative', width: '100%', height: 220 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={parsedData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius={70}
              outerRadius={90}
              paddingAngle={4}
            >
              {parsedData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                  strokeWidth={0}
                />
              ))}
            </Pie>
            <Tooltip
              formatter={(value) => [`${value}%`]}
              contentStyle={{ 
                borderRadius: '12px', 
                border: `1px solid ${theme.palette.divider}`, 
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                backgroundColor: theme.palette.background.paper
              }}
            />
          </PieChart>
        </ResponsiveContainer>

        {/* Texto Central */}
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center'
          }}
        >
          <Typography variant="h4" fontWeight="800" color="primary">
            {value}%
          </Typography>
          <Typography variant="caption" color="textSecondary" sx={{ fontWeight: "700", textTransform: "uppercase" }}>
            {title}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ChartDonut;
